export default __webpack_public_path__ + "static/media/main3_l.d879ad58.jpg";